<template>
  <div :class="startColor + ' bg-white p-4 rounded-lg shadow-md border-t-4  '">
    <div class="flex-col">
      <p class="text-lg font-semibold text-gray-800 py-1">
        {{ labelDolar }}
        <i class="fa-solid fa-dollar-sign text-gray-800 text-xl"></i>
      </p>
      <p class="text-lg font-semibold text-gray-800">{{ labelDinar }} {{ $t("dinar") }}</p>
    </div>
    <div class="flex justify-between w-full">
      <p class="text-lg font-semibold text-gray-800 py-1">{{ labelTitle }}</p>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  labelDolar: {
    type: [String],
    default: "0",
  },
  labelDinar: {
    type: [String],
    default: "0",
  },
  labelTitle: {
    type: [String],
    default: "کۆی داهات",
  },
  classColor: {
    type: [String],
    default: "from-primaryColor",
  },
  startColor: {
    type: [String],
    default: "from-primaryColor",
  },
  toColor: {
    type: [String],
    default: "to-secondaryColor",
  },
  buttonColor: {
    type: [String],
    default: "from-primaryColor",
  },
});
</script>
